<div class="display-career-valuation-organisation">
    <div class="header">
        @if (canSeeData) {
            <dx-date-box (valueChange)="onDateChanged($any($event))"
                         [max]="today"
                         [showClearButton]="true"
                         placeholder="Today"
                         data-test="career-valuation-date"> </dx-date-box>
        } @else {
            Analysis as at {{ today | adaptDate }}
        }

        <div class="ms-auto btn-group">
            <button [adaptButtonToggle]="viewType === careerValuationViewType.Statistics"
                    adaptButtonIcon="fal fa-fw fa-chart-bar"
                    (click)="setViewType(careerValuationViewType.Statistics)"
                    class="btn btn-blank"
                    title="Statistics"></button>

            <button [adaptButtonToggle]="viewType === careerValuationViewType.LatestChart"
                    adaptButtonIcon="fal fa-fw fa-chart-line"
                    (click)="setViewType(careerValuationViewType.LatestChart)"
                    class="btn btn-blank"
                    title="Time chart"></button>

            @if (canSeeData) {
                <button [adaptButtonToggle]="viewType === careerValuationViewType.Grid"
                        adaptButtonIcon="fal fa-fw fa-table"
                        (click)="setViewType(careerValuationViewType.Grid)"
                        class="btn btn-blank"
                        title="Grid"
                        data-test="career-valuation-grid-button"></button>
            }
        </div>
    </div>
    <div class="body">
        <div>
            @switch (viewType) {
                @case (0) {
                    <adapt-cvt-organisation-statistics [date]="date"> </adapt-cvt-organisation-statistics>
                }
                @case (1) {
                    <adapt-cvt-organisation-latest-chart [date]="date"> </adapt-cvt-organisation-latest-chart>
                }
                @case (2) {
                    <adapt-cvt-organisation-grid [date]="date"> </adapt-cvt-organisation-grid>
                }
            }
        </div>
    </div>
</div>
